import React, {useRef, useState, useEffect } from 'react';
import WaveSurfer from 'wavesurfer.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.regions';
import { fetchAuthSession } from 'aws-amplify/auth';
import config from 'client/shared/config';

const wsOptions = async (ref) => {
    // Get the access token
    let accessToken = '';
    try {
        const session = await fetchAuthSession();
        accessToken = session.tokens?.accessToken?.toString() || '';
    } catch (err) {
        console.error('Failed to get access token:', err);
    }

    return {
        barWidth: 3,
        cursorWidth: 1,
        container: '#waveform',
        backend: 'WebAudio',
        progressColor: "#888888",
        responsive: true,
        waveColor: '#888888',
        cursorColor: 'transparent',
        interact: false,
        xhr: {
            requestHeaders: [
                {
                    key: 'Authorization',
                    value: `Bearer ${accessToken}`
                }
            ],
            withCredentials: true
        },
        plugins: [
            RegionsPlugin.create({
                regions: [
                    {
                        id: "preview",
                        start: 1, // time in seconds
                        end: config.rules.MAX_SONG_PREVIEW_LENGTH, // time in seconds
                        color: "hsla(255, 40%, 50%, 0.5)",
                        minLength: config.rules.MAX_SONG_PREVIEW_LENGTH,
                        maxLength: config.rules.MAX_SONG_PREVIEW_LENGTH,
                    }
                ],
                dragSelection: {
                    slop: 5
                },
            })
        ]
    };
};

const playPauseRegion = (ws, isPlaying) => {
  if(!isPlaying) {
    ws.regions.list['preview'].play();

  }
  else {
    ws.pause();

  }
}
export default function Waveform({url, getRegions}) {
    const waveformRef = useRef(null);
    const wavesurfer = useRef(null);
    const [playing, setPlaying] = useState(false);

    useEffect(() => {
        const initWaveSurfer = async () => {
            const options = await wsOptions(waveformRef.current);
            wavesurfer.current = WaveSurfer.create(options);
        
            wavesurfer.current.load(url);
        
            wavesurfer.current.on("ready", function() {
                // make sure object still available when file loaded
                if (wavesurfer.current) {
                    getRegions(wavesurfer.current.regions);
                    // wavesurfer.current.setVolume(volume);
                }
            });
        
            wavesurfer.current.on('region-updated', (region) => {
                let regions = region.wavesurfer.regions.list;
                let keys = Object.keys(regions);
                if(keys.length > 1){
                    regions[keys[0]].remove();
                    // regions[keys[1]].id = "preview";
                    regions[keys[1]].color = "hsla(255, 40%, 50%, 0.5)";
                    regions[keys[1]].minLength = config.rules.MAX_SONG_PREVIEW_LENGTH;
                    regions[keys[1]].maxLength = config.rules.MAX_SONG_PREVIEW_LENGTH;
                }
            });
        };

        initWaveSurfer();

        // Removes events, elements and disconnects Web Audio nodes.
        // when component unmount
        return () => wavesurfer.current?.destroy();
    }, [url]);

    return (
        <div>
            <div id="waveform" ref={waveformRef} />
            <div className="grid-x" style={{color: 'black'}}>
              <i className={playing ? `fas fa-pause` : `fas fa-play`} onClick={() => {
                playPauseRegion(wavesurfer.current, playing);
                setPlaying(!playing);
              }}/>
              <span className="margin-left-1">
                {playing ? 'Pause' : 'Play'} Preview Segment
              </span>
            </div>
        </div>
    )
}